/**
 * Payment comment marker used to indicate that a 478 error was handled
 * by converting a credit card payment to NetTerms payment.
 * This marker is set during checkout and checked in order details to show
 * the appropriate acknowledgement banner.
 */
export const PAYMENT_COMMENT_478_ERROR_HANDLING = "478ErrorHandling";

/**
 * SessionStorage flag raised when the shopper switches away from a currency supported for
 * India shipments (INR or EUR) while in checkout past the shipping address step with an India
 * delivery address. It survives the currency-change page reload so the cart can surface the
 * re-pricing notice.
 */
export const INDIA_INR_REPRICING_FLAG = "checkout:indiaInrRepricing";

/**
 * Currencies accepted for orders shipping to India.
 */
export const INDIA_SUPPORTED_CURRENCIES: readonly string[] = ["INR", "EUR"];

/**
 * Standard checkout step route names that come after the shipping address step.
 */
export const CHECKOUT_STEPS_AFTER_SHIPPING_ADDRESS: readonly string[] = [
  "CheckoutShippingMethod",
  "CheckoutPayment",
  "CheckoutExportItems",
  "CheckoutResellerPreference",
];
